
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Container } from "react-bootstrap";
import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";
import { CastType } from "../../../component/solution/Interfaces";

export const ItemParts: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                <QueryListProvider>
                    <QueryList
                        listTitle={"Stock Master"}
                        recordTitle={"Stock Master"}
                        tableName={"sa_item_parts"}
                        editTableName={"sa_customer"}
                        editHasCompoundKey={false}
                        join={[]} 
                        select={[
                            {
                                fullColumnName: "item_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "item_description",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "item_type",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "item_category",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "fixably_id",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "erp_updated",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            },
                        ]}
                        where={[
                            // {
                            //     fullColumnName: "is_base_item",
                            //     value: false,
                            //     operator: "EQ",
                            //     cast: CastType.BOOLEAN
                            // }
                        ]} 
                        orderBy={[    
                            {
                                fullColumnName: "created",
                                direction: "DESC",
                                cast: CastType.STRING
                            }
                    ]} 
                        groupBy={[]}                   
                    />
                </QueryListProvider>
            </Container>
        </React.Fragment>
    );
}